export default __webpack_public_path__ + "static/media/banner-2-new.65535b68.jpg";